export const SKIP_VALUE: string = '--skip--';
